export default __webpack_public_path__ + "static/media/GaneshchaturtiNew2.9ac92202.JPG";